import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { formatCurrency } from '../helpers'
import { NText } from 'components/styledComponents/text'
import { useWindowSize } from '../helpers'
import { getCurrentResolutionBreakPoint } from 'utils/utilityFunctions'
import { useSelector } from 'react-redux'

export const CardRowItem = (props) => {
  let cardClass = `text-right ${props.rightTextcss && props.rightTextcss}`
  const isDownloadingPdf = useSelector(
    (state) => state.downloadPdf && state.downloadPdf.isDownloading
  )
  const [width] = useWindowSize()
  const resolutionBreakpoint = {
    nonDesktop: getCurrentResolutionBreakPoint(isDownloadingPdf),
  }

  if (width < resolutionBreakpoint.nonDesktop) {
    cardClass = `font-weight-normal ${props.rightTextcss && props.rightTextcss}`
  }

  return (
    <>
      {!props.hideIfNoValue && width >= resolutionBreakpoint.nonDesktop && (
        <Row className="mt-2">
          <Col className="" xs={7} md={9}>
            {props.normalWeight ? <NText>{props.title}</NText> : props.title}
            {props.subtitle && (
              <div className="subtitle">{` ${props.subtitle}`}</div>
            )}
            {props.subtitle2 && (
              <div
                style={{ fontWeight: 400, fontSize: '14px' }}
              >{` ${props.subtitle2}`}</div>
            )}
          </Col>
          {props.isCurrency &&
            (props.subtitle2 && !props.isSubtitle2CcyLarge ? (
              <Col
                xs={5}
                md={3}
                className={cardClass}
                style={{ fontWeight: 400, fontSize: '14px' }}
              >
                {formatCurrency(props.value)}
              </Col>
            ) : (
              <Col xs={5} md={3} className={cardClass}>
                {formatCurrency(props.value)}
              </Col>
            ))}
          {!props.isCurrency && (
            <Col xs={5} md={3} className={cardClass}>
              {props.value}
            </Col>
          )}
        </Row>
      )}
      {!props.hideIfNoValue && width < resolutionBreakpoint.nonDesktop && (
        <>
          <Row>
            <Col className="" xs={12}>
              {props.normalWeight ? <NText>{props.title}</NText> : props.title}
              {props.subtitle && (
                <div className="subtitle">{` ${props.subtitle}`}</div>
              )}
              {props.subtitle2 && (
                <div
                  style={{ fontWeight: 400, fontSize: '14px' }}
                >{` ${props.subtitle2}`}</div>
              )}
            </Col>
          </Row>
          <Row className="mb-3">
            {props.isCurrency &&
              (props.subtitle2 ? (
                <Col
                  xs={12}
                  // className={cardClass}
                  style={{
                    fontWeight: 400,
                    fontSize: '14px',
                    textAlign: 'left',
                  }}
                >
                  {formatCurrency(props.value)}
                </Col>
              ) : (
                <Col xs={12} className={cardClass}>
                  {formatCurrency(props.value)}
                </Col>
              ))}
            {!props.isCurrency && (
              <Col xs={12} className={cardClass}>
                {props.value}
              </Col>
            )}
          </Row>
        </>
      )}
      {props.hideIfNoValue &&
        props.isCurrency &&
        props.value > 0 &&
        width >= resolutionBreakpoint.nonDesktop && (
          <Row className="mt-2">
            <Col xs={7} md={9}>
              {props.normalWeight ? <NText>{props.title}</NText> : props.title}
              {props.subtitle && (
                <div className="subtitle">{` ${props.subtitle}`}</div>
              )}
            </Col>
            <Col xs={5} md={3} className={cardClass}>
              {formatCurrency(props.value)}
            </Col>
          </Row>
        )}
      {props.hideIfNoValue &&
        props.isCurrency &&
        props.value > 0 &&
        width < resolutionBreakpoint.nonDesktop && (
          <>
            <Row>
              <Col xs={12}>
                {props.normalWeight ? (
                  <NText>{props.title}</NText>
                ) : (
                  props.title
                )}
                {props.subtitle && (
                  <div className="subtitle">{` ${props.subtitle}`}</div>
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} className={cardClass}>
                {formatCurrency(props.value)}
              </Col>
            </Row>
          </>
        )}
      {props.hideIfNoValue &&
        props.isCurrency &&
        props.exclGST > 0 &&
        props.inclGST > 0 &&
        width >= resolutionBreakpoint.nonDesktop && (
          <Row className="box">
            <div className="left">
              <span>{props.title}</span>
              {props.subtitle && (
                <span className="subtitle">{` ${props.subtitle}`}</span>
              )}
            </div>
            <div className="value-container">
              <div className="right">{formatCurrency(props.exclGST)}</div>
              <div className="right">{formatCurrency(props.inclGST)}</div>
            </div>
          </Row>
        )}
      {props.hideIfNoValue &&
        props.isCurrency &&
        props.exclGST > 0 &&
        props.inclGST > 0 &&
        width < resolutionBreakpoint.nonDesktop && (
          <>
            <Row className="mb-2">
              <Col>
                <div>{props.title}</div>
                {props.subtitle && (
                  <div className="subtitle">{` ${props.subtitle}`}</div>
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <div className="font-weight-normal text-indictive-color">
                  <b>{formatCurrency(props.exclGST)}</b> (Ex GST)
                </div>
                <div className="font-weight-normal">
                  <b>{formatCurrency(props.inclGST)}</b> (Inc GST)
                </div>
              </Col>
            </Row>
          </>
        )}
      {props.hideIfNoValue &&
        !props.isCurrency &&
        props.value !== null &&
        width >= resolutionBreakpoint.nonDesktop && (
          <Row>
            <Col xs={7} md={9}>
              {props.normalWeight ? <NText>{props.title}</NText> : props.title}
              {props.subtitle && (
                <div className="subtitle">{props.subtitle}</div>
              )}
            </Col>
            <Col xs={5} md={3} className={cardClass}>
              {props.value}
            </Col>
          </Row>
        )}
      {props.hideIfNoValue &&
        !props.isCurrency &&
        props.value !== null &&
        width < resolutionBreakpoint.nonDesktop && (
          <>
            <Row>
              <Col xs={12}>
                {props.normalWeight ? (
                  <NText>{props.title}</NText>
                ) : (
                  props.title
                )}
                {props.subtitle && (
                  <div className="subtitle">{props.subtitle}</div>
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} className={cardClass}>
                {props.value}
              </Col>
            </Row>
          </>
        )}
    </>
  )
}
